<template>
  <div>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-card v-if="reviewPlan.init === 1">
      <v-card-title primary-title>
        <div class="headline">{{labels.premium}}</div>
      </v-card-title>
      <table class="v-datatable v-table theme--light">
        <thead>
          <tr>
            <th class="text-xs-left">Benefit</th>
            <th class="text-xs-left">Description</th>
            <th class="text-xs-right" width="200px">Amount</th>
            <th width="70px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(benefit, index) in premiumInfo.benefits" :key="benefit.value + index">
            <td>{{benefit.value}}</td>
            <td>{{benefit.desc}}</td>
            <td class="text-xs-right">{{currPrefix}}{{formatDisplayNumber(benefit.amt)}}</td>
            <td></td>
          </tr>
          <tr v-if="checkAccess(['travelQuoteShowBen']) && inclGst">
            <td colspan="4" class="inclGstAlert">
              <v-alert :value="true" type="info">
                Benefit(s) premium is inclusive of GST
              </v-alert>
            </td>
          </tr>
          <template v-if="showSummaryDetail">
            <tr class="summaryRow" key="premDue" v-if="checkAccess(['travelQuoteShowDisc'])">
              <td colspan="2">
                <v-layout row wrap align-center>
                  <v-flex>
                    <v-btn flat color="primary" title="Hide Details" @click="showSummaryDetail = false">
                      Hide Details
                      <v-icon right>mdi-chevron-up</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex d-flex>
                    <span class="text-xs-right">
                      Gross Premium
                    </span>
                  </v-flex>
                </v-layout>
              </td>
              <td class="text-xs-right">{{currPrefix}}{{formatDisplayNumber(premiumInfo.premDue)}}</td>
              <td></td>
            </tr>
            <tr class="summaryRow" key="premDue" v-else>
              <td colspan="4">
                <v-layout row wrap align-center>
                  <v-flex>
                    <v-btn flat color="primary" title="Hide Details" @click="showSummaryDetail = false">
                      Hide Details
                      <v-icon right>mdi-chevron-up</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </td>
            </tr>
            <tr class="summaryRow" key="discAmt" v-if="checkAccess(['travelQuoteShowDisc'])">
              <td class="text-xs-right" colspan="2">Disc Amount</td>
              <td class="text-xs-right">({{formatDisplayNumber(premiumInfo.discPct)}}%) {{currPrefix}}{{formatDisplayNumber(premiumInfo.discAmt)}}</td>
              <td>
                <v-icon v-if="canAdjustDisc" color="primary" @click="openShowAdjust">mdi-pencil</v-icon>
              </td>
            </tr>
            <tr class="summaryRow" key="netPremDue" v-if="checkAccess(['travelQuoteShowDisc'])">
              <td class="text-xs-right" colspan="2">
                Net Premium
              </td>
              <td class="text-xs-right">{{currPrefix}}{{formatDisplayNumber(premiumInfo.netPremDue)}}</td>
              <td></td>
            </tr>
            <tr class="summaryRow" key="gstAmt" v-if="checkAccess(['travelQuoteShowDisc'])">
              <td class="text-xs-right" colspan="2">GST Amount</td>
              <td class="text-xs-right">{{currPrefix}}{{formatDisplayNumber(premiumInfo.gstAmt)}}</td>
              <td></td>
            </tr>
            <tr class="summaryRow" key="premiumPayable">
              <td class="text-xs-right text-label" colspan="2">Premium Payable</td>
              <td class="text-xs-right strong-value">{{currPrefix}}{{formatDisplayNumber(premiumInfo.premiumPayable)}}</td>
              <td></td>
            </tr>
            <tr class="breakRow" key="breakRow" v-if="checkAccess(['travelQuoteShowComm'])">
              <td colspan="4"></td>
            </tr>
            <tr class="summaryRow" key="commGN" v-if="checkAccess(['travelQuoteShowComm'])">
              <td class="text-xs-right" colspan="2">Commission G/N</td>
              <td class="text-xs-right">{{premiumInfo.commGN}}</td>
              <td></td>
            </tr>
            <tr class="summaryRow" key="commAmt" v-if="checkAccess(['travelQuoteShowComm'])">
              <td class="text-xs-right" colspan="2">Commission Amount</td>
              <td class="text-xs-right">({{formatDisplayNumber(premiumInfo.commRate)}}%) {{currPrefix}}{{formatDisplayNumber(premiumInfo.commAmt)}}</td>
              <td></td>
            </tr>
          </template>
          <template v-else>
            <tr class="summaryRow" key="premiumPayable2">
              <td colspan="2">
                <v-layout row wrap align-center>
                  <v-flex>
                    <v-btn flat color="primary" title="Show Details" @click="showSummaryDetail = true">
                      Details
                      <v-icon right>mdi-chevron-down</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex d-flex>
                    <span class="text-label text-xs-right">Premium Payable</span>
                  </v-flex>
                </v-layout>
              </td>
              <td class="text-xs-right strong-value">{{currPrefix}}{{formatDisplayNumber(premiumInfo.premiumPayable)}}</td>
              <td></td>
            </tr>
          </template>
        </tbody>
      </table>
    </v-card>
    <loader v-else :height="300" loadText="Calculating Adjustment" errorText="Failed to calculate adjustment" :loading="reviewPlan.init === 0" :errorMsgs="reviewPlan.initErr"></loader>
    <v-layout row wrap class="mt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
    <v-dialog v-model="showAdjust" max-width="600px" lazy>
      <v-card>
        <v-card-title>
          <span class="headline">Discount Adjustment</span>
          <v-spacer></v-spacer>
          <v-btn flat icon @click="showAdjust = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div>
            <v-layout row wrap>
              <v-flex xs2 class="pa-2">
                <span>Min: </span><br/>
                <span class="font-weight-bold">{{formatDisplayNumber(minAdj)}}</span>
              </v-flex>
              <v-flex xs8>
                <v-text-field box v-num-mask v-model="adjDiscount" label="Discount %" type="tel" :error-messages="errors.collect('adjDiscount')" data-vv-name="adjDiscount" data-vv-as="Discount %" v-validate="{ required: true, mask_decimal:2, mask_min_value: minAdj, mask_max_value: maxAdj }" v-if="showAdjust"></v-text-field>
              </v-flex>
              <v-flex xs2 class="pa-2">
                <span>Max: </span><br/>
                <span class="font-weight-bold">{{formatDisplayNumber(maxAdj)}}</span>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat="flat" @click.native="showAdjust = false">Cancel</v-btn>
          <v-btn color="primary" flat="flat" @click.native="doAdjustDisc">Adjust</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { AGENCY_QUOTATION_LIFECYCLE, AGENCY_QUOTATION_DISCADJ } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { formatDisplayNumber } from '@/utils/number'

export default {
  data() {
    return {
      labels: {
        premium: 'Premium Summary'
      },
      showSummaryDetail: false,
      showAdjust: false,
      adjDiscount: undefined
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    premiumInfo() {
      return this.$store.state.agency.quotation.commonInfo.premium
    },
    currPrefix() {
      return this.$store.state.agency.quotation.commonInfo.currPrefix
    },
    reviewPlan() {
      return this.$store.state.agency.quotation.travelParam.reviewPlan
    },
    canAdjustDisc() {
      if (!this.premiumInfo.protDisc && this.checkAccess(['travelQuoteDisc'])) {
        return true
      }
      return false
    },
    minAdj() {
      return 0
    },
    maxAdj() {
      if (this.premiumInfo.commGN === 'G') {
        return this.premiumInfo.commRateMax
      }
      return 100
    },
    inclGst() {
      if (this.premiumInfo.inclGst) {
        return true
      }
      return false
    }
  },
  methods: {
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
      this.$router.push({ name: 'travelQuoteInsured' })
    },
    openShowAdjust() {
      // Assign latest disc % to local state instead of adjDiscount
      // Reason - discount adjustment control is done during calculation, any error will rollback to default (no adjustment)
      // therefore adjDiscount in vuex might not always be accurate
      this.adjDiscount = this.premiumInfo.discPct
      this.showAdjust = true
    },
    doAdjustDisc() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(AGENCY_QUOTATION_DISCADJ, this.adjDiscount)
          this.showAdjust = false
          // Do a recalculate
          this.$store.dispatch('travelQuoteRecalculate')
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    },
    async doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 6)
          this.$router.push({ name: 'travelQuotePayment' })
        } else {
          this.promptFieldCheck()
        }
      })
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 5) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 5)
    }
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss">
.summaryRow {
  background: #eee;
  .text-label {
    font-weight: 600;
  }
  .strong-value {
    font-weight: 600;
  }
}
.breakRow {
  &:hover {
    background: inherit !important;
  }
  td {
    height: 15px !important;
  }
}
.inclGstAlert {
  .v-alert {
    margin: 0 !important;
  }
}
td.inclGstAlert {
  padding: 0 !important;
}
</style>
